















import { Spacing } from '@front-app/components/constants';
import { defineComponent, PropType } from '@vue/composition-api';
import SimpleCard from '../SimpleCard.vue';

export default defineComponent({
	components: { SimpleCard },
	props: {
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.REGULAR,
		},
		suggestRefresh: Boolean,
	},
	setup() {
		return {
			Spacing,
		};
	},
});
